var SpanBranch, SpanLeaf;

SpanLeaf = require('./span-leaf');

SpanBranch = (function() {
  function SpanBranch(children1) {
    var each, j, len, length, ref, spanCount;
    this.children = children1;
    this.indexParent = null;
    spanCount = 0;
    length = 0;
    ref = this.children;
    for (j = 0, len = ref.length; j < len; j++) {
      each = ref[j];
      each.indexParent = this;
      spanCount += each.getSpanCount();
      length += each.getLength();
    }
    this.spanCount = spanCount;
    this.length = length;
  }

  SpanBranch.prototype.clone = function() {
    var children, each, j, len, ref;
    children = [];
    ref = this.children;
    for (j = 0, len = ref.length; j < len; j++) {
      each = ref[j];
      children.push(each.clone());
    }
    return new this.constructor(children);
  };


  /*
  Section: Characters
   */

  SpanBranch.prototype.getLength = function() {
    return this.length;
  };

  SpanBranch.prototype.getString = function() {
    var each, j, len, ref, strings;
    strings = [];
    ref = this.children;
    for (j = 0, len = ref.length; j < len; j++) {
      each = ref[j];
      strings.push(each.getString());
    }
    return strings.join('');
  };

  SpanBranch.prototype.getLocation = function(child) {
    var each, j, len, length, ref, ref1;
    length = ((ref = this.indexParent) != null ? ref.getLocation(this) : void 0) || 0;
    if (child) {
      ref1 = this.children;
      for (j = 0, len = ref1.length; j < len; j++) {
        each = ref1[j];
        if (each === child) {
          break;
        }
        length += each.getLength();
      }
    }
    return length;
  };


  /*
  Section: Spans
   */

  SpanBranch.prototype.getSpanCount = function() {
    return this.spanCount;
  };

  SpanBranch.prototype.getSpan = function(index) {
    var childSpanCount, each, j, len, ref;
    ref = this.children;
    for (j = 0, len = ref.length; j < len; j++) {
      each = ref[j];
      childSpanCount = each.getSpanCount();
      if (index >= childSpanCount) {
        index -= childSpanCount;
      } else {
        return each.getSpan(index);
      }
    }
  };

  SpanBranch.prototype.getSpanIndex = function(child) {
    var each, index, j, len, ref, ref1;
    index = ((ref = this.indexParent) != null ? ref.getSpanIndex(this) : void 0) || 0;
    if (child) {
      ref1 = this.children;
      for (j = 0, len = ref1.length; j < len; j++) {
        each = ref1[j];
        if (each === child) {
          break;
        }
        index += each.getSpanCount();
      }
    }
    return index;
  };

  SpanBranch.prototype.getSpanInfoAtLocation = function(location, spanIndex, spanLocation) {
    var childLength, each, j, len, ref;
    if (spanIndex == null) {
      spanIndex = 0;
    }
    if (spanLocation == null) {
      spanLocation = 0;
    }
    ref = this.children;
    for (j = 0, len = ref.length; j < len; j++) {
      each = ref[j];
      childLength = each.getLength();
      if (location > childLength) {
        location -= childLength;
        spanIndex += each.getSpanCount();
        spanLocation += childLength;
      } else {
        return each.getSpanInfoAtLocation(location, spanIndex, spanLocation);
      }
    }
  };

  SpanBranch.prototype.getSpans = function(start, count) {
    var spans;
    if (start == null) {
      start = 0;
    }
    if (count == null) {
      count = this.getSpanCount() - start;
    }
    spans = [];
    this.iterateSpans(start, count, function(span) {
      return spans.push(span);
    });
    return spans;
  };

  SpanBranch.prototype.iterateSpans = function(spanIndex, count, operation) {
    var child, childSpanCount, j, len, ref, used;
    ref = this.children;
    for (j = 0, len = ref.length; j < len; j++) {
      child = ref[j];
      childSpanCount = child.getSpanCount();
      if (spanIndex < childSpanCount) {
        used = Math.min(count, childSpanCount - spanIndex);
        if (child.iterateSpans(spanIndex, used, operation) === false) {
          return false;
        }
        if ((count -= used) === 0) {
          break;
        }
        spanIndex = 0;
      } else {
        spanIndex -= childSpanCount;
      }
    }
  };

  SpanBranch.prototype.insertSpans = function(spanIndex, spans) {
    var child, childSpanCount, each, i, j, k, len, len1, newleaf, ref, results, spilled;
    this.spanCount += spans.length;
    for (j = 0, len = spans.length; j < len; j++) {
      each = spans[j];
      this.length += each.getLength();
    }
    ref = this.children;
    results = [];
    for (i = k = 0, len1 = ref.length; k < len1; i = ++k) {
      child = ref[i];
      childSpanCount = child.getSpanCount();
      if (spanIndex <= childSpanCount) {
        child.insertSpans(spanIndex, spans);
        if (child instanceof SpanLeaf && child.children.length > 50) {
          while (child.children.length > 50) {
            spilled = child.children.splice(child.children.length - 25, 25);
            newleaf = new SpanLeaf(spilled);
            child.length -= newleaf.length;
            this.children.splice(i + 1, 0, newleaf);
            newleaf.indexParent = this;
          }
          this.maybeSpill();
        }
        break;
      }
      results.push(spanIndex -= childSpanCount);
    }
    return results;
  };

  SpanBranch.prototype.removeSpans = function(spanIndex, removeCount) {
    var child, childDeleteCount, childOldCharactersCount, childSpanCount, i;
    this.spanCount -= removeCount;
    i = 0;
    while (child = this.children[i]) {
      childSpanCount = child.getSpanCount();
      if (spanIndex < childSpanCount) {
        childDeleteCount = Math.min(removeCount, childSpanCount - spanIndex);
        childOldCharactersCount = child.getLength();
        child.removeSpans(spanIndex, childDeleteCount);
        this.length -= childOldCharactersCount - child.getLength();
        if (childSpanCount === childDeleteCount) {
          this.children.splice(i--, 1);
          child.indexParent = null;
        }
        if ((removeCount -= childDeleteCount) === 0) {
          break;
        }
        spanIndex = 0;
      } else {
        spanIndex -= childSpanCount;
      }
      i++;
    }
    return this.maybeCollapse(removeCount);
  };

  SpanBranch.prototype.mergeSpans = function(spanIndex, count) {
    var each, j, len, prev, removeRange, removeRanges, removeStart, results;
    prev = null;
    removeStart = spanIndex;
    removeRanges = [];
    removeRange = null;
    this.iterateSpans(spanIndex, count, function(each) {
      if (prev != null ? prev.mergeWithSpan(each) : void 0) {
        if (!removeRange) {
          removeRange = {
            spanIndex: removeStart({
              count: 0
            })
          };
          removeRanges.push(removeRange);
        }
        return removeRange.count++;
      } else {
        removeRange = null;
        return removeStart++;
      }
    });
    results = [];
    for (j = 0, len = removeRanges.length; j < len; j++) {
      each = removeRanges[j];
      results.push(this.removeSpans(each.spanIndex, each.count));
    }
    return results;
  };


  /*
  Section: Tree Balance
   */

  SpanBranch.prototype.maybeSpill = function() {
    var copy, current, index, sibling, spilled;
    if (this.children.length <= 10) {
      return;
    }
    current = this;
    while (current.children.length > 10) {
      spilled = current.children.splice(current.children.length - 5, 5);
      sibling = new SpanBranch(spilled);
      if (current.indexParent) {
        current.spanCount -= sibling.spanCount;
        current.length -= sibling.length;
        index = current.indexParent.children.indexOf(current);
        current.indexParent.children.splice(index + 1, 0, sibling);
      } else {
        copy = new SpanBranch(current.children);
        copy.indexParent = current;
        current.children = [copy, sibling];
        current = copy;
      }
      sibling.indexParent = current.indexParent;
    }
    return current.indexParent.maybeSpill();
  };

  SpanBranch.prototype.maybeCollapse = function(removeCount) {
    var spans;
    if ((this.spanCount - removeCount) > 25) {
      return;
    }
    if (this.children.length > 1 || !(this.children[0] instanceof SpanLeaf)) {
      spans = [];
      this.collapse(spans);
      this.children = [new SpanLeaf(spans)];
      return this.children[0].indexParent = this;
    }
  };

  SpanBranch.prototype.collapse = function(spans) {
    var each, j, len, ref, results;
    ref = this.children;
    results = [];
    for (j = 0, len = ref.length; j < len; j++) {
      each = ref[j];
      results.push(each.collapse(spans));
    }
    return results;
  };

  return SpanBranch;

})();

module.exports = SpanBranch;



/*****************
 ** WEBPACK FOOTER
 ** ./lib/span-buffer/span-branch.js
 ** module id = 11
 ** module chunks = 0
 **/